import { component } from 'picoapp'
import PredictiveSearch from "@shopify/theme-predictive-search"
import { getSizedImageUrl } from "@shopify/theme-images" 

export default component((node, ctx) => {
  let predictiveInput = document.querySelectorAll('.p-search'); 
  const searchResults = document.querySelector('.p-results');
  var results = [];

  var predictiveSearch = new PredictiveSearch({
    resources: {
      type: [PredictiveSearch.TYPES.PRODUCT],
      limit: 4,
      options: {
        unavailable_products: PredictiveSearch.UNAVAILABLE_PRODUCTS.LAST,
        fields: [
          PredictiveSearch.FIELDS.TITLE,
          PredictiveSearch.FIELDS.VENDOR,
          PredictiveSearch.FIELDS.PRODUCT_TYPE,
          PredictiveSearch.FIELDS.VARIANTS_TITLE,
          PredictiveSearch.FIELDS.TAG
        ]
      }
    }
  }); 
 
  // Set success event listener
  predictiveSearch.on("success", suggestions => {
    window.scrollTo(0,0)
    searchResults.classList.add('is-loaded');
    const productSuggestions = suggestions.resources.results.products;
    console.log(productSuggestions)

    if (productSuggestions.length > 0) {
      searchResults.innerHTML = '';
      for (let i = 0; i < productSuggestions.length; i++) {
        // console.log(productSuggestions[i]);
        // build out the result div
        var product = document.createElement('div');
            product.setAttribute('tabindex', '1');
            product.className = 'result collection-card f fdc jcs';

            // work around so that if the price is 0.00 we re-direct to a project.
            if (productSuggestions[i].price === '0.00' && productSuggestions[i].url.indexOf('swatches') === -1) {
              console.log(productSuggestions[i].url)
              let str = productSuggestions[i].url;
              let projectStr = str.replace('/products/', '/blogs/get-the-look/');
              productSuggestions[i].url = projectStr;
            }
            
            product.innerHTML =
              `
              <div class="product-grid__item">
                <a href="${productSuggestions[i].url}">
                  <div class="product-grid__item--image">
                    <img src="${getSizedImageUrl(productSuggestions[i].image, '430x')}" alt="${productSuggestions[i].title}">
                  </div>
                  <span class="product-grid__item--title raleway caps">
                    ${productSuggestions[i].title}
                  </span>
                  <div class="product-grid__item--price sorts">
                    ${productSuggestions[i].price === '0.00' && productSuggestions[i].url.indexOf('swatches') === -1 ? '<strong>Project</strong>' : `${productSuggestions[i].price}-` }
                  </div>
                </a>
              </div>
              `;
            searchResults.append(product);
      }
      searchResults.insertAdjacentHTML('beforeend',`
        <div class="f jcc aic x">
          <a href="/search?q=${predictiveInput.value}" tabindex="1" class="py1">
            <button class="btn btn--trans">SEE ALL RESULTS</button>
          </a>
        </div>
      `);
    } else {
      searchResults.innerHTML = '<p class="px1 py1 sorts ac x">No results for <u>' + `${predictiveInput.value}` + '</u> found</p>';
    }
    document.body.classList.add('scroll-locked');
  }); 

  // Set error event listener
  predictiveSearch.on("error", error => {
    console.error("Error message:", error.message);
  });


  for (let i = 0; i < predictiveInput.length; i++) {
    const inp = predictiveInput[i];
    
    inp.addEventListener('keyup', function () {
      console.log(inp.value);
      if (inp.value.length == 0) {
        searchResults.innerHTML = '';
        searchResults.classList.remove('is-loaded');
      } else {
        predictiveInput.value = inp.value;
        predictiveSearch.query(inp.value);
      }
    })
  }
})
